export const OnCreateMessageByChatId = /* GraphQL */ `
  subscription OnCreateMessageByChatId($chat_id: String!) {
    OnCreateMessageByChatId(chat_id: $chat_id) {
      id
      content
      createdAt
      chat_id
      image_url
      user_id {
        id
        name
        last_name
        role
      }
    }
  }
`;

export const onCreateMessage = /* GraphQL */ `
  subscription onCreateMessage {
    onCreateMessage {
      id
      content
      createdAt
      chat_id
      image_url
      user_id {
        id
        name
        last_name
        role
      }
    }
  }
`;

export const onUpdateAccountById = /* GraphQL */ `
  subscription onUpdateAccountById($id: ID!) {
    onUpdateAccountById(id: $id) {
      id
      pending_chats
    }
  }
`;

export const onCreateOrderProduct = /* GraphQL */ `
  subscription OnCreateOrderProduct {
    onCreateOrderProduct {
      id
      quantity
      comments
      url_audio
      url_image
      order_id {
        id
        customer_id {
          id
        }
        status
        order_type
        shop_id {
          id
          shop_name
        }
      }
    }
  }
`;

export const onUpdateOrderByID = /* GraphQL */ `
  subscription onUpdateOrderByID($id: ID!) {
    onUpdateOrderByID(id: $id) {
      id
      customer_id {
        id
      }
      canceled
      discount
      final_total
      total
      payment_id
      status
      level
      phase
      shop_id {
        id
        deleted_at
      }
      delivery_man_id {
        id
        role
        name
        last_name
        notification_token
        url_photoProfile
      }
    }
  }
`;

export const onUpdateAccountByRole = /* GraphQL */ `
  subscription onUpdateAccountByRole($role: String!) {
    onUpdateAccountByRole(role: $role) {
      id
      role
      availability
      delivery_inprocess
    }
  }
`;

export const onUpdateOrder = /* GraphQL */ `
  subscription OnUpdateOrder {
    onUpdateOrder {
      id
      customer_id {
        id
        createdAt
        updatedAt
      }
      shop_id {
        id
        shop_name
      }
      status
      level
      discount
      final_total
      products {
        items {
          id
          quantity
        }
        nextToken
      }
      method_pay
      payment_id
      address
      order_type
      delivery_man_id {
        id
        name
        last_name
        availability
      }
      collects {
        items {
          id
          picking_date
          come_date
          type
          origin_sign
          sign
          finished
        }
        nextToken
      }
      require_bill
      require_service
      createdAt
      updatedAt
    }
  }
`;

export const onUpdateOrderByStatus = /* GraphQL */ `
  subscription onUpdateOrderByStatus($status: String!) {
    onUpdateOrderByStatus(status: $statUS) {
      id
    }
  }
`;

export const onCreateWishOrder = /* GraphQL */ `
  subscription onCreateWishOrder {
    onCreateOrder {
      shop_comments
      shop_id {
        id
      }
    }
  }
`;
